/**
 * Teeinblue -> side cart bridge.
 *
 * Teeinblue adds personalized products with its own button (#teeAtcButton),
 * bypassing <product-form>. With its "Add to cart action" set to "redirect"
 * it then sends the shopper to /cart. This keeps the shopper on the product
 * page and opens the side cart (sections/side-cart.liquid) instead.
 *
 * Teeinblue reads window.teeinblue live (cartRedirectDelay) and fires
 * `teeinblue-event-after-cart-added` on document after /cart/add.js.
 */
(function () {
  if (window.__teeinblueCartBridge) return;
  window.__teeinblueCartBridge = true;

  // setTimeout max delay (~24.8 days): Teeinblue's redirect never fires.
  var NO_REDIRECT_DELAY = 2147483647;
  var refreshTimer = null;

  var options = window.teeinblue || {};
  options.cartRedirectDelay = NO_REDIRECT_DELAY;
  window.teeinblue = options;

  function goToCartPage() {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  // With redirect on, Teeinblue leaves its preview dialog open after adding from it.
  function closeTeeinblueDialogs() {
    document.querySelectorAll('.vm--container.tee-dialog .tee-dialog-close').forEach(function (btn) {
      btn.click();
    });
  }

  function showSideCart() {
    refreshTimer = null;
    var sideCart = document.querySelector('side-cart');
    if (!sideCart || typeof sideCart.refresh !== 'function') return goToCartPage();

    closeTeeinblueDialogs();
    sideCart.refresh({ open: true }).catch(function (error) {
      // Item is already in the cart; fall back to the cart page so the shopper still sees it.
      console.error('[teeinblue-cart]', error);
      goToCartPage();
    });
  }

  // One Teeinblue add can fire several events (add-ons, cross-sells); refresh once.
  document.addEventListener('teeinblue-event-after-cart-added', function () {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(showSideCart, 300);
  });
})();
